import {
    APP_LOG_TYPES,
    NO_NEXT_PAGE,
} from '../_constants';

import { genericActions } from './generic.actions';
import { auditLogsActions } from './auditLogs.actions';
import { protectActions } from './protect.actions';
import { userLogsActions } from './userLogs.actions';
import { Selectors } from '../_reducers/app.reducer';
import { deviceLogsActions } from './deviceLogs.actions';

export const logsActions = {
    getFirstPage: (logType, locationUid) => getLogsPage(0, logType, locationUid),
    getNextPage,
};

function getNextPage(nextPage = NO_NEXT_PAGE, isRequesting = false, logType, locationUid) {
    return async dispatch => {
        if (isRequesting || nextPage === NO_NEXT_PAGE)
            return;

        await dispatch(getLogsPage(nextPage, logType, locationUid));
    };
}

function getLogsPage(page = 0, logType, locationUid) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {

            const resolvedLocationUid = locationUid ?? Selectors.getSelectedLocationUid(getState());

            if (resolvedLocationUid === null)
                return;

            switch (logType) {
                case APP_LOG_TYPES.AUDIT:
                    await dispatch(auditLogsActions.getAuditLogsPage(page, locationUid));
                    return;

                case APP_LOG_TYPES.PROTECT:
                    await dispatch(protectActions.getProtectLogsPage(page));
                    return;

                case APP_LOG_TYPES.USER:
                    await dispatch(userLogsActions.getUserLogsPage(page));
                    return;

                case APP_LOG_TYPES.DEVICE:
                    await dispatch(deviceLogsActions.getDeviceLogsFromServer(page));
                    return;
                
                default:
                    return;
            }
        }
    };
}